module.exports = __webpack_public_path__ + "assets/img/2.38f471c3.png";